/* Rheinkauf – Bestellstatus, Rücksendung und „Benachrichtigen, wenn wieder da“.
   Spricht mit dem Rheinkauf-Worker (Cloudflare), gleiche API wie bei WSTND:
     GET  /api/track?no=&email=&lang=de[&scope=return]
     POST /api/returns
     POST /api/notify
   Die Worker-Adresse steht an genau einer Stelle: snippets/rk-api.liquid
   (landet hier als data-rk-api am jeweiligen Block). */
(function () {
  'use strict';

  var LANG = 'de';

  /* ---------- Helfer ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function datum(iso) {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch (e) { return ''; }
  }
  function datumZeit(iso) {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
    } catch (e) { return ''; }
  }
  function eur(n) {
    return Number(n || 0).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }
  function api(base, path) { return String(base || '').replace(/\/+$/, '') + path; }

  function fehlerText(code) {
    switch (code) {
      case 'not_found': return 'Wir finden keine Bestellung zu dieser Kombination. Bitte prüfen Sie Bestellnummer und E-Mail-Adresse – so, wie sie in der Bestellbestätigung stehen.';
      case 'rate_limited': return 'Zu viele Anfragen in kurzer Zeit. Bitte versuchen Sie es in ein paar Minuten noch einmal.';
      case 'not_delivered': return 'Die Bestellung ist noch nicht zugestellt. Eine Rücksendung können Sie anmelden, sobald das Paket bei Ihnen ist.';
      case 'window_expired': return 'Die Rückgabefrist für diese Bestellung ist abgelaufen. Bei einem Defekt melden Sie sich bitte über die Kontaktseite – dann gilt die Gewährleistung.';
      case 'return_open': return 'Für diese Bestellung ist bereits eine Rücksendung angemeldet.';
      case 'qty_invalid': return 'Bitte wählen Sie mindestens einen Artikel und eine gültige Menge.';
      case 'reason_invalid': return 'Bitte wählen Sie für jeden Artikel einen Grund.';
      case 'too_many': return 'Mit dieser Adresse sind schon sehr viele Artikel vorgemerkt.';
      case 'disabled': return 'Die Benachrichtigung ist gerade nicht verfügbar. Bitte versuchen Sie es später noch einmal.';
      case 'bad_request': return 'Bitte prüfen Sie Ihre Eingaben.';
      default: return 'Das hat gerade nicht geklappt. Bitte versuchen Sie es gleich noch einmal oder schreiben Sie uns über die Kontaktseite.';
    }
  }

  async function holen(url, opts) {
    var res, body = null;
    try {
      res = await fetch(url, opts);
    } catch (e) {
      return { ok: false, error: 'network' };
    }
    try { body = await res.json(); } catch (e) { body = null; }
    if (!res.ok) return { ok: false, status: res.status, error: (body && body.error) || 'server_error' };
    return { ok: true, status: res.status, data: body };
  }

  /* ---------- Texte für Status-Codes (Worker liefert nur Codes) ---------- */
  var STATUS = {
    storniert: ['Storniert', 'rk-st--grau'],
    bearbeitung: ['In Bearbeitung', 'rk-st--gelb'],
    unterwegs: ['Unterwegs', 'rk-st--blau'],
    teilweise: ['Teilweise versandt', 'rk-st--blau'],
    verzoegert: ['Verzögert', 'rk-st--rot'],
    zugestellt: ['Zugestellt', 'rk-st--gruen']
  };

  function etaText(eta) {
    if (!eta) return '';
    var d = datum(eta.dueAt);
    switch (eta.code) {
      case 'cancelled': return 'Diese Bestellung wurde storniert.';
      case 'delivered_one_at': return 'Zugestellt am ' + d + '.';
      case 'delivered_all_at': return 'Alle Pakete zugestellt, zuletzt am ' + d + '.';
      case 'delivered_one': return 'Ihr Paket wurde zugestellt.';
      case 'delivered_all': return 'Alle Pakete wurden zugestellt.';
      case 'stuck_some': return 'Paket ' + (eta.packets || []).join(', ') + ' hat seit längerem keinen neuen Scan. Wir haken beim Versender nach.';
      case 'stuck_all': return 'Ihre Sendung hat seit längerem keinen neuen Scan. Wir haken beim Versender nach – melden Sie sich gern, falls es eilt.';
      case 'due_one': return 'Voraussichtliche Zustellung: ' + d + '.';
      case 'due_first': return 'Das erste Paket kommt voraussichtlich am ' + d + '.';
      case 'ship_soon': return 'Wir packen Ihre Bestellung. Sobald sie unterwegs ist, kommt eine E-Mail mit der Sendungsnummer.';
      case 'deliver_soon': return 'Ihr Paket ist unterwegs und kommt in den nächsten Tagen.';
      default: return '';
    }
  }

  var SCHRITT = {
    packed: 'Im Lager gepackt',
    handover: 'An {carrier} übergeben',
    handover_generic: 'An den Versender übergeben',
    accepted: 'Vom Versender übernommen',
    hub_origin: 'Im Start-Paketzentrum',
    hub: 'Im Paketzentrum',
    hub_dest: 'Im Ziel-Paketzentrum',
    customs: 'Zollabfertigung',
    arrived_country: 'Im Zielland angekommen',
    out_for_delivery: 'In Zustellung',
    failed: 'Zustellung nicht möglich',
    failed_attempt: 'Zustellung nicht möglich',
    attempt_failed: 'Zustellung nicht möglich',
    pickup_branch: 'Zur Abholung in der Filiale',
    packstation: 'In der Packstation',
    neighbour: 'Beim Nachbarn abgegeben',
    returning: 'Auf dem Rückweg zu uns',
    delivered: 'Zugestellt',
    update: 'Neue Meldung vom Versender',
    rma_registered: 'Rücksendung angemeldet',
    rma_shipped: 'Paket an uns unterwegs',
    rma_arrived: 'Bei uns eingetroffen',
    rma_checked: 'Geprüft',
    rma_refunded: 'Erstattet'
  };
  function schrittText(st) {
    if (st.c === 'other' && st.raw) return st.raw;
    var t = SCHRITT[st.c];
    if (!t) {
      if (/^hub/.test(st.c)) t = 'Im Paketzentrum';
      else if (/fail|attempt/.test(st.c)) t = 'Zustellung nicht möglich';
      else t = 'Neue Meldung vom Versender';
    }
    return t.replace('{carrier}', st.carrier || 'den Versender');
  }

  function artikelListe(items, mitMenge) {
    return '<ul class="rk-p-art">' + (items || []).map(function (it) {
      return '<li>' +
        (it.image ? '<img src="' + esc(it.image) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="rk-p-art__ph"></span>') +
        '<span><strong>' + esc(it.name) + '</strong>' +
        (it.variant && it.variant !== 'Default Title' ? '<br><small>' + esc(it.variant) + '</small>' : '') +
        (mitMenge !== false ? '<br><small>Menge: ' + esc(it.qty) + '</small>' : '') +
        '</span></li>';
    }).join('') + '</ul>';
  }

  function zeitleiste(steps) {
    return '<ol class="rk-p-zeit">' + (steps || []).map(function (st) {
      return '<li class="rk-p-zeit__s rk-p-zeit__s--' + esc(st.s || 'pending') + '">' +
        '<span class="rk-p-zeit__punkt" aria-hidden="true"></span>' +
        '<span class="rk-p-zeit__t">' + esc(schrittText(st)) + '</span>' +
        (st.at ? '<span class="rk-p-zeit__d">' + esc(datumZeit(st.at)) + '</span>' : '') +
        '</li>';
    }).join('') + '</ol>';
  }

  /* ---------- Bestellstatus ---------- */
  function initTrack(root) {
    var form = $('form', root);
    var out = $('[data-rk-out]', root);
    var base = root.getAttribute('data-rk-api');

    /* Vorbelegung aus der URL (?no=&email=), z. B. aus der Versandmail */
    var q = new URLSearchParams(location.search);
    if (q.get('no')) form.elements.no.value = q.get('no');
    if (q.get('email')) form.elements.email.value = q.get('email');

    async function suchen() {
      var no = form.elements.no.value.trim();
      var email = form.elements.email.value.trim();
      if (!no || !email) return;
      var btn = $('button[type=submit]', form);
      btn.disabled = true; btn.textContent = 'Wird gesucht …';
      out.innerHTML = '';
      var r = await holen(api(base, '/api/track') + '?no=' + encodeURIComponent(no) + '&email=' + encodeURIComponent(email) + '&lang=' + LANG);
      btn.disabled = false; btn.textContent = 'Bestellung suchen';
      if (!r.ok) { out.innerHTML = '<p class="rk-p-fehler">' + esc(fehlerText(r.error)) + '</p>'; return; }
      out.innerHTML = renderTrack(r.data, no, email);
      out.scrollIntoView({ block: 'start' });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); suchen(); });
    if (q.get('no') && q.get('email')) suchen();
  }

  function renderTrack(d, no, email) {
    var st = STATUS[d.state] || ['Status', 'rk-st--grau'];
    var h = '<div class="rk-p-karte">' +
      '<div class="rk-p-kopf"><div><p class="rk-p-klein">Bestellung ' + esc(d.id) + ' vom ' + esc(datum(d.placedAt)) + '</p>' +
      '<h2 class="rk-p-h2">' + esc(etaText(d.eta)) + '</h2></div>' +
      '<span class="rk-st ' + st[1] + '">' + esc(st[0]) + '</span></div>';

    (d.shipments || []).forEach(function (s) {
      h += '<div class="rk-p-paket"><h3 class="rk-p-h3">' +
        ((d.shipments.length > 1) ? 'Paket ' + esc(s.nr) : 'Ihre Sendung') +
        (s.carrier ? ' · ' + esc(s.carrier) : '') + '</h3>' +
        (s.tracking ? '<p class="rk-p-klein">Sendungsnummer: ' +
          (s.trackUrl ? '<a href="' + esc(s.trackUrl) + '" target="_blank" rel="noopener">' + esc(s.tracking) + '</a>' : esc(s.tracking)) + '</p>' : '') +
        (s.dueAt ? '<p class="rk-p-klein">Voraussichtlich: ' + esc(datum(s.dueAt)) + '</p>' : '') +
        zeitleiste(s.steps) + artikelListe(s.items) + '</div>';
    });

    if (d.open && d.open.length) {
      h += '<div class="rk-p-paket"><h3 class="rk-p-h3">Noch nicht versandt</h3>' + artikelListe(d.open) + '</div>';
    }
    if (d.shipTo && d.shipTo.length) {
      h += '<div class="rk-p-paket"><h3 class="rk-p-h3">Lieferadresse</h3><p>' + d.shipTo.map(esc).join('<br>') + '</p></div>';
    }
    if (d.deliveredAt) {
      h += '<div class="rk-p-paket rk-p-hinweis">' + (d.returnOpen
        ? '<p><strong>Rückgabe möglich bis ' + esc(datum(d.returnUntil)) + '.</strong> Etwas passt nicht? <a href="/pages/ruecksendung?no=' + encodeURIComponent(no) + '&email=' + encodeURIComponent(email) + '">Rücksendung anmelden</a></p>'
        : '<p>Die Rückgabefrist von ' + esc(d.returnDays) + ' Tagen ist abgelaufen. Bei einem Defekt helfen wir Ihnen trotzdem: <a href="/pages/beratung-und-kontakt">Kontakt</a></p>') + '</div>';
    }
    return h + '</div>';
  }

  /* ---------- Rücksendung ---------- */
  var GRUENDE = [
    ['gefaellt_nicht', 'Gefällt mir nicht / anders überlegt'],
    ['passt_nicht', 'Entspricht nicht der Beschreibung'],
    ['defekt', 'Beschädigt oder defekt'],
    ['falsch', 'Falscher Artikel geliefert'],
    ['anderer', 'Anderer Grund']
  ];
  var KOSTENLOS = ['defekt', 'falsch'];

  function initReturn(root) {
    var form = $('form', root);
    var out = $('[data-rk-out]', root);
    var base = root.getAttribute('data-rk-api');
    var preis = parseFloat(root.getAttribute('data-rk-label-preis') || '0') || 0;
    var stand = null;

    var q = new URLSearchParams(location.search);
    if (q.get('no')) form.elements.no.value = q.get('no');
    if (q.get('email')) form.elements.email.value = q.get('email');

    async function suchen() {
      var no = form.elements.no.value.trim();
      var email = form.elements.email.value.trim();
      if (!no || !email) return;
      var btn = $('button[type=submit]', form);
      btn.disabled = true; btn.textContent = 'Wird gesucht …';
      out.innerHTML = '';
      var r = await holen(api(base, '/api/track') + '?no=' + encodeURIComponent(no) + '&email=' + encodeURIComponent(email) + '&lang=' + LANG + '&scope=return');
      btn.disabled = false; btn.textContent = 'Weiter';
      if (!r.ok) { out.innerHTML = '<p class="rk-p-fehler">' + esc(fehlerText(r.error)) + '</p>'; return; }
      stand = { no: no, email: email, d: r.data };
      out.innerHTML = renderReturn(r.data, preis);
      bindReturn(out, base, preis, stand);
      out.scrollIntoView({ block: 'start' });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); suchen(); });
    if (q.get('no') && q.get('email')) suchen();
  }

  function belege(o) {
    var h = '<div class="rk-p-belege">';
    if (o.labelUrl) h += '<a class="rk-p-btn" href="' + esc(o.labelUrl) + '" target="_blank" rel="noopener">DHL-Retourenlabel (PDF)</a>';
    if (o.qrUrl) h += '<a class="rk-p-btn rk-p-btn--hell" href="' + esc(o.qrUrl) + '" target="_blank" rel="noopener">QR-Code für die Filiale</a>';
    if (o.slipUrl) h += '<a class="rk-p-btn rk-p-btn--hell" href="' + esc(o.slipUrl) + '" target="_blank" rel="noopener">Retourenschein (PDF)</a>';
    return h + '</div>';
  }

  function renderReturn(d, preis) {
    var kopf = '<p class="rk-p-klein">Bestellung ' + esc(d.id) + ' vom ' + esc(datum(d.placedAt)) + '</p>';

    if (d.openReturn) {
      var o = d.openReturn;
      return '<div class="rk-p-karte">' + kopf +
        '<h2 class="rk-p-h2">Rücksendung ' + esc(o.rma) + ' ist angemeldet</h2>' +
        '<p>Angemeldet am ' + esc(datum(o.createdAt)) + (o.shipmentNo ? ' · DHL-Sendungsnummer ' + esc(o.shipmentNo) : '') + '.</p>' +
        belege(o) + zeitleiste(o.steps) + '</div>';
    }
    if (d.block === 'unterwegs') {
      return '<div class="rk-p-karte">' + kopf + '<h2 class="rk-p-h2">Ihr Paket ist noch unterwegs</h2>' +
        '<p>Eine Rücksendung können Sie anmelden, sobald es bei Ihnen angekommen ist. Die Frist beginnt erst mit der Zustellung.</p>' +
        '<p><a href="/pages/bestellung-verfolgen?no=' + encodeURIComponent(d.id) + '">Sendung verfolgen</a></p></div>';
    }
    if (d.block === 'frist') {
      return '<div class="rk-p-karte">' + kopf + '<h2 class="rk-p-h2">Die Rückgabefrist ist abgelaufen</h2>' +
        '<p>Zugestellt am ' + esc(datum(d.deliveredAt)) + ', die Frist beträgt ' + esc(d.returnDays) + ' Tage. Bei einem Defekt gilt die gesetzliche Gewährleistung – <a href="/pages/beratung-und-kontakt">schreiben Sie uns</a>.</p></div>';
    }

    var zeilen = (d.items || []).map(function (it, i) {
      var opts = '';
      for (var n = 0; n <= Number(it.qty || 1); n++) opts += '<option value="' + n + '">' + n + '</option>';
      return '<li class="rk-p-ret" data-sku="' + esc(it.sku) + '">' +
        (it.image ? '<img src="' + esc(it.image) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="rk-p-art__ph"></span>') +
        '<div class="rk-p-ret__info"><strong>' + esc(it.name) + '</strong>' +
        (it.variant && it.variant !== 'Default Title' ? '<br><small>' + esc(it.variant) + '</small>' : '') +
        '<br><small>' + esc(eur(it.price)) + ' · bestellt: ' + esc(it.qty) + '</small>' +
        '<div class="rk-p-ret__felder">' +
        '<label>Menge zurück <select name="qty-' + i + '">' + opts + '</select></label>' +
        '<label>Grund <select name="reason-' + i + '"><option value="">Bitte wählen</option>' +
        GRUENDE.map(function (g) { return '<option value="' + g[0] + '">' + esc(g[1]) + '</option>'; }).join('') +
        '</select></label></div>' +
        '<label class="rk-p-ret__notiz">Anmerkung (optional)<input name="note-' + i + '" maxlength="300"></label>' +
        '</div></li>';
    }).join('');

    var weg = d.labelAvailable
      ? '<fieldset class="rk-p-weg"><legend>Wie senden Sie zurück?</legend>' +
        '<label><input type="radio" name="method" value="label" checked> DHL-Retourenlabel von uns' +
        (preis > 0 ? ' <small>(' + esc(eur(preis)) + ', wird von der Erstattung abgezogen – kostenlos bei Defekt oder Falschlieferung)</small>' : ' <small>(kostenlos)</small>') + '</label>' +
        '<label><input type="radio" name="method" value="selbst"> Ich frankiere selbst</label></fieldset>'
      : '<p class="rk-p-klein">Sie senden das Paket selbst frankiert an uns zurück. Die Anschrift steht auf dem Retourenschein.</p>';

    return '<div class="rk-p-karte">' + kopf +
      '<h2 class="rk-p-h2">Was möchten Sie zurücksenden?</h2>' +
      '<p class="rk-p-klein">Zugestellt am ' + esc(datum(d.deliveredAt)) + ' · noch ' + esc(d.daysLeft) + ' Tage Rückgabefrist</p>' +
      '<form data-rk-ret novalidate><ul class="rk-p-retliste">' + zeilen + '</ul>' + weg +
      '<p class="rk-p-summe" data-rk-summe></p>' +
      '<p class="rk-p-fehler" data-rk-fehler hidden></p>' +
      '<button class="rk-p-btn" type="submit">Rücksendung verbindlich anmelden</button></form></div>';
  }

  function bindReturn(out, base, preis, stand) {
    var f = $('form[data-rk-ret]', out);
    if (!f) return;
    var items = stand.d.items || [];
    var fehler = $('[data-rk-fehler]', f);
    var summe = $('[data-rk-summe]', f);

    function auswahl() {
      var sel = {}, waren = 0, frei = false, anzahl = 0;
      items.forEach(function (it, i) {
        var qty = parseInt(f.elements['qty-' + i].value, 10) || 0;
        if (!qty) return;
        var reason = f.elements['reason-' + i].value;
        sel[it.sku] = { qty: qty, reason: reason, note: (f.elements['note-' + i].value || '').slice(0, 300) };
        waren += Number(it.price || 0) * qty;
        if (KOSTENLOS.indexOf(reason) !== -1) frei = true;
        anzahl++;
      });
      var method = f.elements.method ? (f.querySelector('input[name=method]:checked') || {}).value : 'selbst';
      var gebuehr = (!frei && method === 'label') ? preis : 0;
      return { sel: sel, anzahl: anzahl, waren: waren, gebuehr: gebuehr, method: method || 'selbst' };
    }

    function aktualisieren() {
      var a = auswahl();
      summe.innerHTML = a.anzahl
        ? 'Warenwert ' + esc(eur(a.waren)) + (a.gebuehr ? ' − Retourenlabel ' + esc(eur(a.gebuehr)) : '') +
          ' = <strong>Erstattung ' + esc(eur(Math.max(0, a.waren - a.gebuehr))) + '</strong>'
        : '';
    }
    f.addEventListener('change', aktualisieren);

    f.addEventListener('submit', async function (e) {
      e.preventDefault();
      fehler.hidden = true;
      var a = auswahl();
      if (!a.anzahl) { fehler.textContent = fehlerText('qty_invalid'); fehler.hidden = false; return; }
      for (var k in a.sel) { if (!a.sel[k].reason) { fehler.textContent = fehlerText('reason_invalid'); fehler.hidden = false; return; } }

      var btn = $('button[type=submit]', f);
      btn.disabled = true; btn.textContent = 'Wird angemeldet …';
      var r = await holen(api(base, '/api/returns'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order: stand.no, email: stand.email, method: a.method, payout: 'erstattung', items: a.sel, lang: LANG })
      });
      if (!r.ok) {
        btn.disabled = false; btn.textContent = 'Rücksendung verbindlich anmelden';
        fehler.textContent = fehlerText(r.error); fehler.hidden = false; return;
      }
      var d = r.data;
      out.innerHTML = '<div class="rk-p-karte"><h2 class="rk-p-h2">Rücksendung ' + esc(d.rma) + ' ist angemeldet</h2>' +
        (d.labelUrl
          ? '<p>Drucken Sie das DHL-Label aus und kleben Sie es aufs Paket. Ohne Drucker: QR-Code in der Filiale zeigen, DHL druckt das Label dort aus.</p>'
          : '<p>Bitte frankieren Sie das Paket selbst. Die Anschrift steht auf dem Retourenschein.</p>') +
        '<p><strong>Legen Sie den Retourenschein ins Paket</strong> – nur so können wir die Sendung Ihrer Bestellung zuordnen.</p>' +
        belege(d) +
        (d.notified ? '<p class="rk-p-klein">Die Unterlagen haben wir Ihnen zusätzlich per E-Mail geschickt.</p>' : '') +
        '</div>';
      out.scrollIntoView({ block: 'start' });
    });
  }

  /* ---------- Benachrichtigen, wenn wieder da ---------- */
  function initNotify(root) {
    var base = root.getAttribute('data-rk-api');
    var daten = {};
    try { daten = JSON.parse($('script[type="application/json"]', root).textContent); } catch (e) {}
    var form = $('form', root);
    var ok = $('[data-rk-ok]', root);
    var fehler = $('[data-rk-fehler]', root);
    var aktuell = null;

    function varianteJetzt() {
      var feld = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = (feld && feld.value) || new URLSearchParams(location.search).get('variant') || daten.first;
      return String(id || '');
    }
    function pruefen() {
      var id = varianteJetzt();
      if (id === aktuell) return;
      aktuell = id;
      var verfuegbar = daten.v ? daten.v[id] : true;
      root.hidden = verfuegbar !== false;
      ok.hidden = true; form.hidden = false; fehler.hidden = true;
    }
    document.addEventListener('change', function () { setTimeout(pruefen, 50); });
    window.addEventListener('popstate', pruefen);
    setInterval(pruefen, 800); /* Varianten-Picker schreiben die ID nicht immer mit Event */
    pruefen();

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      fehler.hidden = true;
      var email = form.elements.email.value.trim();
      if (!email) return;
      var btn = $('button', form);
      btn.disabled = true;
      var r = await holen(api(base, '/api/notify'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ variantId: aktuell, email: email, lang: LANG })
      });
      btn.disabled = false;
      if (!r.ok) { fehler.textContent = fehlerText(r.error); fehler.hidden = false; return; }
      if (r.data && r.data.available) { location.reload(); return; }
      form.hidden = true; ok.hidden = false;
    });
  }

  function start() {
    document.querySelectorAll('[data-rk-track]').forEach(initTrack);
    document.querySelectorAll('[data-rk-return]').forEach(initReturn);
    document.querySelectorAll('[data-rk-notify]').forEach(initNotify);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
